import { reactive } from 'vue'
import instance from '@/api/instance'
import { iRegion, iUserIdentity } from '@/types/responses'

const loadDefaultRegion = (): number | undefined => {
  const cookieValue = (new Map<string, string>(
    document.cookie.split(';').map(cookie => cookie.split('=').map(v => v.trim()) as [string, string])
  )).get('regionId')
  return cookieValue && cookieValue !== 'undefined' ? parseInt(cookieValue) : undefined
}

const state = reactive<{
  user?: iUserIdentity
  regions: iRegion[]
  regionId: number|undefined
}>({
  user: undefined,
  regions: [],
  regionId: loadDefaultRegion()
})

export default {
  state,
  login (user: iUserIdentity) {
    state.user = user
    instance.defaults.headers.common['X-Api-Key'] = user.token
    document.cookie = `cToken=${user.token}`
  },
  logout () {
    state.user = undefined
    delete instance.defaults.headers.common['X-Access-Token']
    document.cookie = 'cToken='
  },
  setRegions (regions: iRegion[]) {
    state.regions = regions
  },
  setCurrentRegion (regionId: number|undefined) {
    state.regionId = regionId
    document.cookie = `regionId=${regionId}`
  }
}
